export default __webpack_public_path__ + "long-arrow-pointing-to-the-right.png";